import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import propTypes from "prop-types";
import videojs from "video.js";
import firebase from "firebase/app";
import Button from "./Button/Button.base";

import "video.js/dist/video-js.css";
import "../styles/videoL.css";

const style = {
  width: "100%"
};

class VideoPlayer extends Component {
  constructor(props) {
    super(props);
    this.video = React.createRef();
    this.state = {
      isPlaying: false,
      buttonLabel: "Play",
      hasAlreadyEvaluate: false
    };
  }

  componentDidMount() {
    this.player = videojs(this.video.current, {
      sources: [
        {
          src: this.props.src,
          type: "video/mp4"
        }
      ]
    });

    firebase
      .database()
      .ref(`/videos/${this.props.videoId}/evaluations`)
      .once("value")
      .then((snapshot) => {
        return snapshot.child(this.props.user.uid).val()
          ? this.setState({hasAlreadyEvaluate: true})
          : null
      })
    ;
  }

  componentWillUnmount() {
    this.player && this.player.dispose();
  }

  playToggle = () => {
    if (this.state.isPlaying === true) {
      this.setState({
        isPlaying: false,
        buttonLabel: "Play"
      });
      this.props.history.push("/pitchs");
    } else {
      this.player.play();
      this.setState({
        isPlaying: true,
        buttonLabel: "Stop"
      });
    }
  };

  whenEnded = () => {
    this.props.user.uid !== this.props.owner 
    && !this.state.hasAlreadyEvaluate
      ? this.props.history.push(`/pitchs/${this.props.videoId}/evaluate`)
      : this.props.history.push(`/pitchs`);
  };

  render() {    
    return (
      <div className="VideoLoader" onClick={this.playToggle}>
        <video
          onEnded={this.whenEnded}
          ref={this.video}
          className="video-js vjs-default-skin"
          data-setup="{&quot;fluid&quot;: true}"
          playsInline
        />
        <Button
          style={style}
          className="ButtonPlay"
          label={this.state.buttonLabel}
          disabled={false}
          onClick={this.playToggle}
        />
      </div>
    );
  }
}

VideoPlayer.propTypes = {
  src: propTypes.string.isRequired,
  videoId: propTypes.string.isRequired,
  owner: propTypes.string.isRequired,
  user: propTypes.object.isRequired
};

export default withRouter(VideoPlayer);
